import React from 'react';
import { Segment, Header, Tab, Button, Responsive, Grid, Divider, Icon, Label, Input, Image } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-widgets/dist/css/react-widgets.css';

import ContactFormEditable from '../../util/ContactFormEditable';
import PreviousEducations from './PreviousEducations';
import request from '../../util/request';
import FacultyChanges from './FacultyChanges';
import PlaceForm from '../../util/PlaceForm';
import ActivityStatusForm from './FormParts/ActivityStatusForm';
import ParentsInfoForm from './FormParts/ParentsInfoForm';
import BasicInfoForm from './FormParts/BasicInfoForm';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class StudentCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //
            socialStatuses:[],
            personSocialStatuses:[],
            selectedSocialStatusTypes: [],
            genders: [],
            citizenships: [],
            nationalities: [],
            educationLevels: [],
            municipalities: [],
            cantons: [],
            entities: [],
            activityStatusTypes: [],
            occupationStatuses: [],
            institutionTypes: [],
            faculties: [],

            description: '',

            bihId: null,
            fbihId: null,
            rsId: null,
            bdId: null,


            // FORM DATA
            jmbg: '',
            firstName: '',
            lastName: '',
            maidenName: '',
            dateOfBirth: new Date(),
            gender: null,
            selectedCitizenships: [],
            nationality: null,

            // ERROR Failed
            jmbgErr: false,
            firstNameErr: false,
            lastNameErr: false,
            maidenNameErr: false,
            genderErr: false,

            citizenshipsErr: false,
            activityStatusTypeErr: false,

            placeOfResidenceCountryErr: false,
            placeOfResidenceEntityErr: false,
            placeOfResidenceCantonErr: false,
            placeOfResidenceMunicipalityErr: false,
            placeOfResidencePlaceErr: false,
            placeOfResidenceAddressErr: false,

            placeOfBirthCountryErr: false,
            placeOfBirthEntityErr: false,
            placeOfBirthCantonErr: false,
            placeOfBirthMunicipalityErr: false,
            placeOfBirthPlaceErr: false,

            placeOfCurrentResidenceCountryErr: false,
            placeOfCurrentResidenceEntityErr: false,
            placeOfCurrentResidenceCantonErr: false,
            placeOfCurrentResidenceMunicipalityErr: false,
            placeOfCurrentResidencePlaceErr: false,
            placeOfCurrentResidenceAddressErr: false,

            // parents
            fatherFirstName: null,
            fatherLastName: null,
            fatherGender: null,

            motherFirstName: null,
            motherLastName: null,
            motherGender: null,

            contacts: [],
            previousEducations: [],

            // father and mother info
            occupationStatusF: null,
            occupationF: null,
            activityStatusTypeF: null,

            occupationStatusM: null,
            occupationM: null,
            activityStatusTypeM: null,

            occupationStatus: null,
            occupation: null,
            activityStatusType: null,

            facultyChanges: [],

            placeOfResidence: {
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            placeOfCurrentResidence: {
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            placeOfBirth: {
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            src: '',
            selectedFile: null,

            activeIndex: 0

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateofBirthChange = this.handleDateofBirthChange.bind(this);
        this.onAddNewContact = this.onAddNewContact.bind(this);
        this.onDeleteContact = this.onDeleteContact.bind(this);


        this.onSubmit = this.onSubmit.bind(this);
        this.showNationality = this.showNationality.bind(this);

        this.onAddNewPreviousEducation = this.onAddNewPreviousEducation.bind(this);
        this.onDeletePreviousEducation = this.onDeletePreviousEducation.bind(this);

        this.onAddNewFacultyChange = this.onAddNewFacultyChange.bind(this);
        this.onDeleteFacultyChange = this.onDeleteFacultyChange.bind(this);

        this.onChangeCustom = this.onChangeCustom.bind(this);
        this.resetFormData = this.resetFormData.bind(this);

        this.removeActivityStatus = this.removeActivityStatus.bind(this);

        this.getDefaultActivityStatusId = this.getDefaultActivityStatusId.bind(this);

        this.onPlaceChange = this.onPlaceChange.bind(this);
        this.getActiveStatusId = this.getActiveStatusId.bind(this);
    }

    UNSAFE_componentWillMount() {
        axios.get('/entities')
            .then(res => {
                this.setState({ rsId: res.data.find(el => el._key === 'rs').id, bdId: res.data.find(el => el._key === 'bd').id });
            });
    }


    resetFormData() {
        this.setState({
            //
            socialStatuses:[],
            personSocialStatuses:[],
            selectedSocialStatusTypes: [],

            description: '',

            bihId: null,
            fbihId: null,


            // FORM DATA
            jmbg: '',
            firstName: '',
            lastName: '',
            maidenName: '',
            dateOfBirth: new Date(),
            gender: null,
            selectedCitizenships: [],
            nationality: null,

            // ERROR Failed
            jmbgErr: false,
            firstNameErr: false,
            lastNameErr: false,
            maidenNameErr: false,
            genderErr: false,

            citizenshipsErr: false,
            activityStatusTypeErr: false,

            placeOfResidenceCountryErr: false,
            placeOfResidenceEntityErr: false,
            placeOfResidenceCantonErr: false,
            placeOfResidenceMunicipalityErr: false,
            placeOfResidencePlaceErr: false,
            placeOfResidenceAddressErr: false,

            placeOfBirthCountryErr: false,
            placeOfBirthEntityErr: false,
            placeOfBirthCantonErr: false,
            placeOfBirthMunicipalityErr: false,
            placeOfBirthPlaceErr: false,

            placeOfCurrentResidenceCountryErr: false,
            placeOfCurrentResidenceEntityErr: false,
            placeOfCurrentResidenceCantonErr: false,
            placeOfCurrentResidenceMunicipalityErr: false,
            placeOfCurrentResidencePlaceErr: false,
            placeOfCurrentResidenceAddressErr: false,


            // parents
            fatherFirstName: null,
            fatherLastName: null,
            fatherGender: null,

            motherFirstName: null,
            motherLastName: null,
            motherGender: null,

            contacts: [],
            previousEducations: [],

            // father and mother info
            occupationStatusF: null,
            occupationF: null,
            activityStatusTypeF: null,

            occupationStatusM: null,
            occupationM: null,
            activityStatusTypeM: null,

            occupationStatus: null,
            occupation: null,
            activityStatusType: null,

            facultyChanges: [],

            placeOfResidence: {
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            placeOfCurrentResidence: {
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            placeOfBirth: {
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            selectedFile: null,
            sr:''
        });

        toast('Dodavanje studenta je uspješno izvršeno.');
    }

    componentDidMount() {
        let activeRole = localStorage.getItem('activeRole');
        window.localStorage.clear();
        localStorage.setItem('activeRole', activeRole);

        request.fetchGendersWithDefaultKeys()
            .then(({ genders, defaultMaleGenderId, defaultFemaleGenderId }) => {
                this.setState({ genders, fatherGender: defaultMaleGenderId, motherGender: defaultFemaleGenderId });
            }).catch(err => console.log(err));
        request.fetchNationalitiesWithDefaultKey()
            .then(({ nationalities, defaultUnknownNationalityId }) => {
                this.setState({ nationalities, nationality: defaultUnknownNationalityId });
            }).catch(err => console.log(err));
        request.fetchContactTypes()
            .then(contactTypes => this.setState({ contactTypes }))
            .catch(err => console.log(err));
        request.fetchEducationLevels()
            .then(educationLevels => this.setState({ educationLevels }))
            .catch(err => console.log(err));
        request.fetchCitizenships()
            .then(citizenships => this.setState({ citizenships }));
        request.fetchInstitutionTypes()
            .then(institutionTypes => this.setState({ institutionTypes }));
        request.fetchActivityStatusTypes()
            .then(activityStatusTypes => this.setState({
                activityStatusTypes,
                activityStatusType: this.getDefaultActivityStatusId(activityStatusTypes),
                activeStatusId: this.getActiveStatusId(activityStatusTypes)
            }));
        request.fetchOccupationStatuses()
            .then(occupationStatuses => this.setState({ occupationStatuses }));
        request.fetchRawFaculties()
            .then(faculties => this.setState({ faculties }));
        request.fetchCountriesWithDefaultKey()
            .then(({ bihId }) => this.setState({ bihId }));
        request.fetchEntitiesWithDefaultKey()
            .then(({ fbihId }) => this.setState({ fbihId }));
        request.fetchSocialStatuses()
            .then(socialStatuses => this.setState({ socialStatuses }));
    }
    handleDateofBirthChange(date) {
        this.setState({ dateOfBirth: date });
    }

    getActiveStatusId(activityStatusTypes) {
        const selected = activityStatusTypes.find(el => el.text === 'zaposlen');
        if (selected && selected.key) return selected.key;
        return '';
    }

    getDefaultActivityStatusId(activityStatusTypes) {
        const selected = activityStatusTypes.find(el => el.text === 'neaktivan');
        if (selected && selected.key) return selected.key;
        return '';
    }
    onSubmit() {
        if (!this.state.jmbg || !this.state.firstName || !this.state.lastName || !this.state.gender
            || (this.state.selectedCitizenships.length === 0) || !this.state.activityStatusType ||

            !this.state.placeOfResidence.country ||
            ((this.state.placeOfResidence.country && this.state.placeOfResidence.country === this.state.bihId) && !this.state.placeOfResidence.entity) ||
            ((this.state.placeOfResidence.entity && this.state.placeOfResidence.entity === this.state.fbihId)
                && (!this.state.placeOfResidence.canton || !this.state.placeOfResidence.municipality))
            || (this.state.placeOfResidence.entity && this.state.placeOfResidence.entity === this.state.rsId && !this.state.placeOfResidence.municipality)
            || !this.state.placeOfResidence.address || !this.state.placeOfResidence.place ||

            !this.state.placeOfBirth.country ||
            ((this.state.placeOfBirth.country && this.state.placeOfBirth.country === this.state.bihId) && !this.state.placeOfBirth.entity) ||
            ((this.state.placeOfBirth.entity && this.state.placeOfBirth.entity === this.state.fbihId)
                && (!this.state.placeOfBirth.canton || !this.state.placeOfBirth.municipality))
            || (this.state.placeOfBirth.entity && this.state.placeOfBirth.entity === this.state.rsId && !this.state.placeOfBirth.municipality)
            || !this.state.placeOfBirth.place ||

            (this.state.placeOfCurrentResidence.country &&
                (!this.state.placeOfCurrentResidence.place || !this.state.placeOfCurrentResidence.address
                    || ((this.state.placeOfCurrentResidence.country === this.state.bihId) && !this.state.placeOfCurrentResidence.entity))
                || (this.state.placeOfCurrentResidence.entity && this.state.placeOfCurrentResidence.entity === this.state.fbihId
                    && (!this.state.placeOfCurrentResidence.canton || !this.state.placeOfCurrentResidence.municipality))
                || (this.state.placeOfCurrentResidence.entity && this.state.placeOfCurrentResidence.entity === this.state.rsId && !this.state.placeOfCurrentResidence.municipality)
            )
        ) {
            toast('Niste unijeli sva obavezna polja!');
            if (!this.state.jmbg) { this.setState({ jmbgErr: true }); } else { this.setState({ jmbgErr: false }); }
            if (!this.state.firstName) { this.setState({ firstNameErr: true }); } else { this.setState({ firstNameErr: false }); }
            if (!this.state.lastName) { this.setState({ lastNameErr: true }); } else { this.setState({ lastNameErr: false }); }
            if (!this.state.gender) { this.setState({ genderErr: true }); } else { this.setState({ genderErr: false }); }
            if (this.state.selectedCitizenships.length === 0) { this.setState({ citizenshipsErr: true }); } else { this.setState({ citizenshipsErr: false }); }

            if (!this.state.placeOfResidence.country) { this.setState({ placeOfResidenceCountryErr: true }); } else { this.setState({ placeOfResidenceCountryErr: false }); }
            if (!this.state.placeOfResidence.address) { this.setState({ placeOfResidenceAddressErr: true }); } else { this.setState({ placeOfResidenceAddressErr: false }); }
            if (!this.state.placeOfResidence.place) { this.setState({ placeOfResidencePlaceErr: true }); } else { this.setState({ placeOfResidencePlaceErr: false }); }

            if (this.state.placeOfResidence.country === this.state.bihId) {
                if (!this.state.placeOfResidence.entity) { this.setState({ placeOfResidenceEntityErr: true }); } else { this.setState({ placeOfResidenceEntityErr: false }); }
                if (this.state.placeOfResidence.entity === this.state.fbihId) {
                    if (!this.state.placeOfResidence.canton) { this.setState({ placeOfResidenceCantonErr: true }); } else { this.setState({ placeOfResidenceCantonErr: false }); }
                    if (!this.state.placeOfResidence.municipality) { this.setState({ placeOfResidenceMunicipalityErr: true }); } else { this.setState({ placeOfResidenceMunicipalityErr: false }); }
                }
                if (this.state.placeOfResidence.entity === this.state.rsId) {
                    if (!this.state.placeOfResidence.municipality) { this.setState({ placeOfResidenceMunicipalityErr: true }); } else { this.setState({ placeOfResidenceMunicipalityErr: false }); }
                }
            }

            if (!this.state.placeOfBirth.country) { this.setState({ placeOfBirthCountryErr: true }); } else { this.setState({ placeOfBirthCountryErr: false }); }
            if (!this.state.placeOfBirth.place) { this.setState({ placeOfBirthPlaceErr: true }); } else { this.setState({ placeOfBirthPlaceErr: false }); }

            if (this.state.placeOfBirth.country === this.state.bihId) {
                if (!this.state.placeOfBirth.entity) { this.setState({ placeOfBirthEntityErr: true }); } else { this.setState({ placeOfBirthEntityErr: false }); }
                if (this.state.placeOfBirth.entity === this.state.fbihId) {
                    if (!this.state.placeOfBirth.canton) { this.setState({ placeOfBirthCantonErr: true }); } else { this.setState({ placeOfBirthCantonErr: false }); }
                    if (!this.state.placeOfBirth.municipality) { this.setState({ placeOfBirthMunicipalityErr: true }); } else { this.setState({ placeOfBirthMunicipalityErr: false }); }
                }
                if (this.state.placeOfBirth.entity === this.state.rsId) {
                    if (!this.state.placeOfBirth.municipality) { this.setState({ placeOfBirthMunicipalityErr: true }); } else { this.setState({ placeOfBirthMunicipalityErr: false }); }
                }
            }

            if (!this.state.activityStatusType) { this.setState({ activityStatusTypeErr: true }); } else { this.setState({ activityStatusTypeErr: false }); }

            if (this.state.placeOfCurrentResidence.country === this.state.bihId) {
                if (!this.state.placeOfCurrentResidence.entity) { this.setState({ placeOfCurrentResidenceEntityErr: true }); } else { this.setState({ placeOfCurrentResidenceEntityErr: false }); }
                if (this.state.placeOfCurrentResidence.entity === this.state.fbihId) {
                    if (!this.state.placeOfCurrentResidence.canton) { this.setState({ placeOfCurrentResidenceCantonErr: true }); } else { this.setState({ placeOfCurrentResidenceCantonErr: false }); }
                    if (!this.state.placeOfCurrentResidence.municipality) { this.setState({ placeOfCurrentResidenceMunicipalityErr: true }); } else { this.setState({ placeOfCurrentResidenceMunicipalityErr: false }); }
                }
                if (this.state.placeOfCurrentResidence.entity === this.state.rsId) {
                    if (!this.state.placeOfCurrentResidence.municipality) { this.setState({ placeOfCurrentResidenceMunicipalityErr: true }); } else { this.setState({ placeOfCurrentResidenceMunicipalityErr: false }); }
                }
            }
        } else {
            const requestData = request.formatAndValidateForRequest(this.state, false);

            axios.post('/students/student/', { ...requestData.data })
                .then(res => {
                    if(this.state.selectedFile !== null) this.onFileUpload(res.data.id);
                    this.resetFormData();
                    toast('Uspješno ste dodali studenta.');
                }).catch(err => {
                    if (err.response.data === 'Person with this JMBG already exists!') {
                        toast('Student sa ovim JMBG-om već postoji!');
                    } else {
                        toast('Došlo je do greške! Dodavanje studenta nije uspjelo.');
                    }
                });
        }
    }

    onAddNewContact(newContact) {
        this.setState({ contacts: [...this.state.contacts, newContact] });
    }

    onDeleteContact(value, type) {
        const { contacts } = this.state;
        const filteredContacts = contacts.filter(el => el.value !== value);
        this.setState({ contacts: filteredContacts });
    }


    handleInputChange(e, { name, value }) {
        if (name === 'gender') {this.setState({maidenName:''})};
        this.setState({ [name]: value });
    }
    showNationality() {
        return !!this.state.selectedCitizenships.find(el => this.state.bihId === el);
    }
    onAddNewPreviousEducation(prevEducation) {
        const { previousEducations } = this.state;
        this.setState({ previousEducations: [...previousEducations, prevEducation] });
    }
    onDeletePreviousEducation(index) {
        const filtered = this.state.previousEducations.filter((el, i) => i !== index);
        this.setState({ previousEducations: filtered });
    }
    onAddNewFacultyChange(facultyId) {
        const faculty = this.state.faculties.find(el => el.id === facultyId);
        if (faculty) this.setState({ facultyChanges: [...this.state.facultyChanges, faculty] });
    }
    onDeleteFacultyChange(facultyId) {
        const filtered = this.state.facultyChanges.filter(el => el.id != facultyId);
        this.setState({ facultyChanges: filtered });
    }
    onChangeCustom(name, value, formName) {
        this.setState({ [formName]: { ...this.state[formName], [name]: value } });
    }
    removeActivityStatus() {
        this.setState({ occupationStatus: null, activityStatusType: null, occupation: '' });
    }
    onPlaceChange(values, formName) {
        this.setState({ [formName]: values });
    }

    onFileChange = event => {
        this.setState({ selectedFile: event.target.files[0], src: URL.createObjectURL(event.target.files[0])
        })
    };

    onFileUpload = (studentId) => {
        const formData = new FormData();
        formData.append(
            "imageFile",
            this.state.selectedFile,
            this.state.selectedFile.name
        );

        axios.post(`/students/${studentId}/uploadImage`, formData)
            .then(res=>{
                this.setState({ selectedFile: null });
            })
            .catch(err=> {
                this.setState({ selectedFile: null });
            })

    };

    handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex })

    render() {
        const panes = [
            {
                menuItem: 'Osnovne informacije',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div><br /><BasicInfoForm
                        firstName={this.state.firstName}
                        jmbg={this.state.jmbg}
                        lastName={this.state.lastName}
                        maidenName={this.state.maidenName}
                        dateOfBirth={this.state.dateOfBirth}
                        handleInputChange={this.handleInputChange}
                        handleDateChange={this.handleDateofBirthChange}
                        gender={this.state.gender}
                        genders={this.state.genders}
                        citizenships={this.state.citizenships}
                        selectedCitizenships={this.state.selectedCitizenships}
                        nationalities={this.state.nationalities}
                        nationality={this.state.nationality}
                        bihId={this.state.bihId}
                        formName="basicInfo"

                        jmbgErr={this.state.jmbgErr}
                        firstNameErr={this.state.firstNameErr}
                        lastNameErr={this.state.lastNameErr}
                        genderErr={this.state.genderErr}
                        citizenshipsErr={this.state.citizenshipsErr}
                        socialStatuses={this.state.socialStatuses}
                        selectedSocialStatusTypes={this.state.selectedSocialStatusTypes}
                    /></div>
                </Tab.Pane>),
            },
            {
                menuItem: 'Mjesto rođenja',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div><br /><PlaceForm
                        values={this.state.placeOfBirth}
                        formName="placeOfBirth"
                        onPlaceChange={this.onPlaceChange}
                        countryErr={this.state.placeOfBirthCountryErr}
                        entityErr={this.state.placeOfBirthEntityErr}
                        cantonErr={this.state.placeOfBirthCantonErr}
                        municipalityErr={this.state.placeOfBirthMunicipalityErr}
                        placeErr={this.state.placeOfBirthPlaceErr}
                        noAdress
                        //bdId={this.state.bdId}
                    /></div>
                </Tab.Pane>),
            },
            {
                menuItem: 'Informacije o roditeljima',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div><br /><ParentsInfoForm
                        genders={this.state.genders}
                        fatherFirstName={this.state.fatherFirstName}
                        fatherLastName={this.state.fatherLastName}
                        fatherGender={this.state.fatherGender}
                        motherFirstName={this.state.motherFirstName}
                        motherLastName={this.state.motherLastName}
                        motherGender={this.state.motherGender}
                        onChange={this.handleInputChange}

                        activityStatusTypes={this.state.activityStatusTypes}
                        occupationStatuses={this.state.occupationStatuses}

                        activityStatusTypeM={this.state.activityStatusTypeM}
                        occupationStatusM={this.state.occupationStatusM}
                        occupationM={this.state.occupationM}

                        activityStatusTypeF={this.state.activityStatusTypeF}
                        occupationStatusF={this.state.occupationStatusF}
                        occupationF={this.state.occupationF}

                        handleInputChange={this.handleInputChange}
                        removeActivityStatus={this.removeActivityStatus}
                        activeStatusId={this.getActiveStatusId(this.state.activityStatusTypes)}
                    /></div>
                </Tab.Pane>),
            },
            {
                menuItem: 'Prebivalište i boravište',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        <Grid columns="equal" centered className="stackable">
                            <Grid.Row streched>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4">Prebivalište</Header>
                                    </Divider>
                                    <PlaceForm
                                        values={this.state.placeOfResidence}
                                        formName="placeOfResidence"
                                        onPlaceChange={this.onPlaceChange}
                                        countryErr={this.state.placeOfResidenceCountryErr}
                                        entityErr={this.state.placeOfResidenceEntityErr}
                                        cantonErr={this.state.placeOfResidenceCantonErr}
                                        municipalityErr={this.state.placeOfResidenceMunicipalityErr}
                                        placeErr={this.state.placeOfResidencePlaceErr}
                                        addressErr={this.state.placeOfResidenceAddressErr}
                                        //bdId={this.state.bdId}
                                    /></Grid.Column>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4">Boravište</Header>
                                    </Divider>
                                    <PlaceForm
                                        values={this.state.placeOfCurrentResidence}
                                        formName="placeOfCurrentResidence"
                                        onPlaceChange={this.onPlaceChange}
                                        countryErr={this.state.placeOfCurrentResidenceCountryErr}
                                        entityErr={this.state.placeOfCurrentResidenceEntityErr}
                                        cantonErr={this.state.placeOfCurrentResidenceCantonErr}
                                        municipalityErr={this.state.placeOfCurrentResidenceMunicipalityErr}
                                        placeErr={this.state.placeOfCurrentResidencePlaceErr}
                                        addressErr={this.state.placeOfCurrentResidenceAddressErr}
                                        //bdId={this.state.bdId}
                                    /></Grid.Column>
                            </Grid.Row></Grid>
                    </div>
                </Tab.Pane>),
            },
            {
                menuItem: 'Kontakt informacije',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <ContactFormEditable
                        contactTypes={this.state.contactTypes}
                        onAddNewContact={this.onAddNewContact}
                        contacts={this.state.contacts.map(el => ({ type: this.state.contactTypes.find(e => e.key === el.contactTypeId).text, value: el.value }))}
                        onDeleteContact={this.onDeleteContact}
                        editMode
                        createNewStudent
                        noSegment
                    />
                </Tab.Pane>),
            },
            {
                menuItem: 'Status u aktivnosti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div><br /><ActivityStatusForm
                        activityStatusTypes={this.state.activityStatusTypes}
                        occupationStatuses={this.state.occupationStatuses}
                        activityStatusType={this.state.activityStatusType}
                        occupationStatus={this.state.occupationStatus}
                        occupation={this.state.occupation}
                        handleInputChange={this.handleInputChange}
                        removeActivityStatus={this.removeActivityStatus}
                        activeStatusId={this.getActiveStatusId(this.state.activityStatusTypes)}
                        errorStatus={this.state.activityStatusTypeErr}
                    /></div>
                </Tab.Pane>),
            },
            {
                menuItem: 'Prethodno obrazovanje',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <PreviousEducations
                        studentCreateMode
                        institutionTypes={this.state.institutionTypes}
                        educationLevels={this.state.educationLevels}
                        institutions={this.state.institutions}
                        onAddNewPreviousEducation={this.onAddNewPreviousEducation}
                        previousEducations={this.state.previousEducations}
                        onDeletePreviousEducation={this.onDeletePreviousEducation}
                        noSegment
                    /></Tab.Pane>),
            },
            // {
            //     menuItem: 'Promjena fakulteta',
            //     render: () => (<Tab.Pane attached={false} as={Responsive}>
            //         <FacultyChanges
            //             faculties={this.state.faculties}
            //             onAddNewFacultyChange={this.onAddNewFacultyChange}
            //             onDeleteFacultyChange={this.onDeleteFacultyChange}
            //             facultyChanges={this.state.facultyChanges}
            //             noSegment
            //         />
            //     </Tab.Pane>),
            // },
            {
                menuItem: 'Fotografija studenta',
                render: () => (<Tab.Pane attached={false} as={Responsive}><div>
                    { this.state.src !== '' ?
                        <div style={{textAlign: 'center'}}>
                            <Image src={this.state.src} size='large' centered />
                            <br/>
                            <Button disabled={this.state.selectedFile === null} color="blue" basic onClick={()=>this.setState({selectedFile: null, src: ''})}>
                                Poništi
                            </Button>
                        </div>

                    : <div style={{textAlign:'center', marginTop:'10%', marginBottom:'10%'}}>
                    <br/>
                    <br/>
                    <Button as="div" labelPosition="right">
                        <Button color="blue" as="label" htmlFor="file" type="button" onChange={this.onFileChange}>
                            <Icon name="upload" />
                        </Button>
                        <Label style={{ cursor: 'none' }} basic pointing="left">
                            {this.state.selectedFile === null ?
                                'Odaberite fotografiju studenta'
                                : 'Fotografija je odabrana'
                            }
                        </Label>
                    </Button>

                    <Input type="file" id="file" style={{ display: 'none' }} onChange={this.onFileChange} />

                    <br/>
                    <br/>
                        </div>}
                </div></Tab.Pane>),
            },
        ];
        return (
            <div>

                <h1> Unos studenta </h1>

                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            Podaci o studentu
                        </Header>
                    </Segment>

                    <Segment>
                        <Tab
                            panes={panes}
                            menu={{
                                secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                            }}
                            onTabChange={this.handleTabChange}
                            activeIndex={this.state.activeIndex}
                            grid={{ paneWidth: 13, tabWidth: 3 }}
                        />
                    </Segment>


                    <Segment clearing>
                        {this.state.activeIndex > 6 ?
                            <Button primary onClick={this.onSubmit} floated="right">Dodaj studenta</Button>:''}
                        {this.state.activeIndex < 5 ?   <Button content='Nastavi' icon='right arrow'  basic color='blue' labelPosition='right' onClick={()=> this.setState({activeIndex: this.state.activeIndex+1})} floated="right"/>:''}
                        {this.state.activeIndex > 4 && this.state.activeIndex < 7 ?
                            <Button.Group floated="right">
                                <Button color={'blue'} primary onClick={this.onSubmit} >Završi unos i dodaj studenta</Button>
                                <Button.Or text='ili' />
                                <Button icon='right arrow' content='Nastavi' basic color='blue' labelPosition='right' onClick={()=> this.setState({activeIndex: this.state.activeIndex+1})}/>
                            </Button.Group>
                            :''}
                            {this.state.activeIndex > 0 ?
                            <Button content='Nazad' icon='left arrow'  basic color='blue' labelPosition='left' onClick={()=> this.setState({activeIndex: this.state.activeIndex-1})} floated="left"/>:''}
                    </Segment>

                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentCreateAndEdit/StudentCreate.js